import { FC, SVGProps } from 'react';

export const ArrowLongLeftIcon2: FC<SVGProps<SVGSVGElement>> = ({ stroke = '#141414', ...props }) => (
  <svg width="14" height="7" viewBox="0 0 14 7" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M3.47998 1.02047L1 3.50049L3.47998 5.98047" stroke={stroke} strokeLinecap="round" strokeLinejoin="round" />
    <path d="M13 3.50391L1 3.50391" stroke={stroke} strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
